export interface ContractIdAttachmentRequest {
  attachmentTypeId?: string;
  description: string;
  filePath: string;
  fileName: string;
}
